// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"5491229e","453":"df9d5160"}[chunkId] + ".chunk.js";
};